import { AdminChargebackCasesScreen } from '@features/admin/ui/AdminChargebackCasesScreen'

export function ChargebacksPage() {
  return <AdminChargebackCasesScreen />
}
